import querystring from 'query-string';
import { Identity, ResponseError } from '@ynap/api-utils';
import { raygun } from '@ynap/clientside-monitoring';
import { timeout, delay } from '@ynap/promise-utils';
import { REGISTER_REQUEST, REGISTER_ERROR } from '../constants/ActionTypes';
import setUberToken from './setUberToken';
import { dispatchUserChangeEvent, redirectToUrl, tmHeadersParams } from './utils';

function registerRequest() {
    return {
        type: REGISTER_REQUEST,
    };
}

function registerError(error) {
    return {
        type: REGISTER_ERROR,
        error,
    };
}

export default function register(credentials, requestDelay, shouldRedirect = true, successCallback) {
    return (dispatch, getState, wcsFetch) => {
        const { config, deviceType, locale, router, uberToken } = getState();
        const { location = {} } = router;
        const { query = {} } = location;
        const { country, language } = locale;
        const { clientRequest, consentTermsAndConditionsField } = config.head || config;
        const { baseUrl, clientId, clientSecret } = config.watsonService || config.global.services.commerce;
        const { brandId } = config.watsonService || config.global.application;
        const { search = '' } = location;
        const { excludePartnerizeAttribute = false, tierExpansionEnabled } = config.head;

        const contextAttribute = credentials.hasOwnProperty('maMarketingConsent')
            ? [
                  {
                      attributeName: 'maMarketingConsent',
                      attributeValue: {
                          value: `${credentials.maMarketingConsent}`,
                      },
                  },
                  {
                      attributeName: 'maMarketingEmailStandard',
                      attributeValue: {
                          value: `${credentials.maMarketingConsent}`,
                      },
                  },
                  ...(tierExpansionEnabled
                      ? [
                            {
                                attributeName: 'maLoyaltyConsent',
                                attributeValue: {
                                    value: 'true',
                                },
                            },
                        ]
                      : []),
              ]
            : tierExpansionEnabled
              ? [
                    {
                        attributeName: 'maLoyaltyConsent',
                        attributeValue: {
                            value: 'true',
                        },
                    },
                ]
              : undefined;
        const affiliateUser = credentials.affiliate ? [{ name: 'Centurion' }] : undefined;

        const params = {
            ...credentials,
            contextAttribute,
            logonPasswordVerify: credentials.logonPassword,
            customerSegments: affiliateUser,
        };
        const { tmEnabled, tmSessionId, ...registrationParams } = params;

        const additionalHeaders = tmEnabled ? tmHeadersParams('register', { ...credentials, sessionId: tmSessionId, country, deviceType }, config) : {};

        const request = Identity.register({
            baseUrl,
            brandId,
            country,
            credentials: registrationParams,
            uberToken,
            clientId,
            clientSecret,
            additionalHeaders,
            excludePartnerizeAttribute,
        });

        const { redirect = affiliateUser ? `/${locale.id}/account/affiliate-confirmation` : `/${locale.id}/account` } = querystring.parse(search.substring(1));

        dispatch(registerRequest());

        return delay(timeout(wcsFetch(request), clientRequest.timeout), requestDelay || clientRequest.delay)
            .then((response) => {
                const { ok } = response;

                if (ok) {
                    successCallback?.();
                    return response
                        .json()
                        .then((json) => {
                            const fetchUserSummary = true;
                            dispatch(setUberToken(json.Ubertoken));
                            dispatchUserChangeEvent(json.Ubertoken, null, fetchUserSummary);
                            window.parent.postMessage({ type: 'updateUbertoken', uberToken: json.Ubertoken }, '*');
                            consentTermsAndConditionsField &&
                                wcsFetch(
                                    Identity.consentTermsAndConditions({
                                        baseUrl,
                                        brandId,
                                        country,
                                        clientId,
                                        language,
                                        consentField: consentTermsAndConditionsField,
                                        uberToken: json.Ubertoken,
                                    }),
                                );
                            return json;
                        })
                        .then(() => {
                            const { iframe = 'false' } = query;

                            if ((iframe !== 'true' || !iframe) && shouldRedirect) {
                                redirectToUrl(redirect, location, locale);
                            }
                        });
                }

                throw new ResponseError(response);
            })
            .catch((error) => {
                dispatch(registerError(error));
                raygun.helpers.agent('send', {
                    error,
                    tags: ['Register action', 'Error'],
                });
                throw error;
            });
    };
}
